import React, { Component } from 'react';
import { SyncLoader } from 'react-spinners';
// css
import './Shared.css';

const gibberish = [
  "Loading",
  "Setting up a few things",
  "Just a little bit longer",
  "Wait, wait, wait...",
  "Digging a hole",
  "Setting the sun on fire",
  "brb, talking to Zeus",
  "This is taking a while, eh?",
  "Gosh, this is embarrasing...",
];

class Loading extends Component {
  constructor(props) {
    super(props);
    let {
      text = gibberish[0],
    } = this.props;
    this.state = { text: text };
  }

  componentDidMount() {
    const {
      text,
      hideText,
     } = this.props;
    if (text === void 0 && !hideText) {
      this.interval = setInterval(this.updateTextToNextGibberish, 3 * 1000);
    }
  }

  componentWillUnmount() {
    if (this.interval) {
      clearInterval(this.interval);
    }
  }

  render() {
    const {
      color = "#00bc99",
      size = 8,
      inline = false,
      hideText = false,
    } = this.props;

    const style = {
      display: inline ? "inline-block" : "block",
    };
    return (
      <div className="Loading" style={style}>
        { hideText ? null : <span className="Loading-text">{this.state.text}</span> }
        <span><SyncLoader size={size} color={color} /></span>
      </div>
    );
  }

  updateTextToNextGibberish = () => {
    let len = gibberish.length;
    let currIndex = gibberish.indexOf(this.state.text);
    let nextIndex = (currIndex + 1) % len;
    this.setState({ text: gibberish[nextIndex] });
  }

}

export default Loading;


// WEBPACK FOOTER //
// ./src/components/Shared/Loading.js